import './App.css';
import { useContext } from 'react';
import { GTIThemeProvider } from "@gti-controls-v2/web-core";
import { AuthProvider } from './providers/auth';
import { LocaleContext, LocaleProvider } from './providers/locale';
import { SearchProvider } from './providers/search';
import customTheme from "./theme";
import AppRouter from './router';

function ThemeWrapper(props) {
	const localeContext = useContext(LocaleContext);

	return (
		<GTIThemeProvider
			theme={customTheme}
			locale={localeContext.locale}
		>
			{props.children}
		</GTIThemeProvider>
	);
};

/** App */
function App() {
	return (
		<LocaleProvider>
			<ThemeWrapper>
				<AuthProvider>
					<SearchProvider>
						<AppRouter />
					</SearchProvider>
				</AuthProvider>
			</ThemeWrapper>
		</LocaleProvider>
	);
};

export default App;